
import {  
    CATEGORY_VARIANT_REQUEST,
    CATEGORY_VARIANT_SUCCESS,
    CATEGORY_VARIANT_FAILURE, } from "../actions/actionTypes";
  
  const initialState = {
    categoryVariant: [],
    recordsTotal: 0,
    loading: false,
    error: null,
  };

  const categoryVariantReducer = (state = initialState, action) => {
    switch (action.type) {
      case CATEGORY_VARIANT_REQUEST:
        return { ...state, loading: true, error: null };

      case CATEGORY_VARIANT_SUCCESS:
        return {
          ...state,
          loading: false,
          categoryVariant: action.payload?.data ?? [],
          recordsTotal: action.payload?.recordsTotal ?? 0,
        };
  
      case CATEGORY_VARIANT_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default categoryVariantReducer;
  